import React from 'react';
import { AppBar as MuiAppBar, Toolbar, Typography, Button, Box, IconButton, Tooltip, styled } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import { useSidebar } from '../../context/SidebarContext';
import { useTheme } from '../../context/ThemeContext';
import { usePage } from '../../context/PageContext';

import { Logout as LogoutIcon, PermContactCalendar as CardIcon, InvertColors, Menu as MenuIcon } from '@mui/icons-material';
import { drawerWidth } from './SideMenu';

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    // Mobile responsiveness
    [theme.breakpoints.down('md')]: {
        width: '100% !important',
        marginLeft: '0 !important',
    },
}));

const Navbar = () => {
    const { token } = useAuth();
    const { isOpen, toggleSidebar } = useSidebar();
    const { switchTheme } = useTheme();
    const { pageTitle } = usePage();

    return (
        <AppBar position="fixed" open={isOpen}>
            <Toolbar>
                {token && (
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={toggleSidebar}
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}
                <CardIcon sx={{ mr: 2 }} />
                <Typography variant="h6" noWrap component="div" sx={{ 
                    flexGrow: 1,
                    fontSize: { xs: '0.9rem', sm: '1.1rem' },
                    display: { xs: 'none', sm: 'block' }
                }}>
                    {pageTitle}
                </Typography>
                <Tooltip title="Switch Theme">
                    <IconButton onClick={() => switchTheme()} color="inherit">
                        <InvertColors />
                    </IconButton>
                </Tooltip>
                <AuthButtons />
            </Toolbar>
        </AppBar>
    );
};

const AuthButtons = () => {
    const { token, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

    if (token) {
        return (
            <Tooltip title="Logout">
                <IconButton color="inherit" onClick={handleLogout} aria-label="logout">
                    <LogoutIcon />
                </IconButton>
            </Tooltip>
        );
    }

  return (
            <Button color="inherit" component={Link} to="/login">
              Login
            </Button>
  );
};

export default Navbar; 